<template>
  <v-layout column md12>
    <div class="mb-3">
      <page-title
        title="Projects General Report"
        :useBackBtn="false"
      ></page-title>
    </div>

    <v-card elevation="1" class="col-md-12 mt-2">
      <div class="row">
        <div class="col-md-4 col-sm-12">
          <v-card flat class="col-md-12">
            <div class="col-md-12">
              <ProjectGauge :heightData="300" :seriesData="[57]" />
            </div>
            <h3 class="text-dark pa-3">
              Timeline : <br />
              <span style="font-size: 24px"
                >January 30,2022 - February 30, 2025</span
              >
            </h3>
          </v-card>
        </div>
        <div class="col-md-8 col-sm-12">
          <v-card flat>
            <v-chart class="chart col-md-11" :option="option" />
          </v-card>
        </div>
      </div>
    </v-card>

    <v-card elevation="1" class="col-md-12">
      <v-simple-table>
        <template>
          <thead>
            <tr>
              <th class="text-left">Project</th>
              <th class="text-left">Activities</th>
              <th class="text-left">Sub-Activities</th>
              <th class="text-left">Start Date</th>
              <th class="text-left">End Date</th>
              <th class="text-left">Actions</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="item in reportData" :key="item.name">
              <td>{{ item.name }}</td>
              <td>
                {{ item.components }}

                <br />
                <span class="text-dark">
                  <v-progress-linear
                    :color="
                      item.percentage > 60
                        ? 'green'
                        : item.percentage < 45
                        ? 'orange'
                        : 'blue'
                    "
                    v-model="item.percentage"
                    :buffer-value="100"
                    height="20"
                  >
                   <template v-slot:default="{ value }">
                      <strong>{{ Math.ceil(value) }}%</strong>
                    </template>
                  </v-progress-linear>
                </span>
              </td>
              <td>
                {{ item.subComponents }}

                <br />
                <span class="text-dark">
                  <v-progress-linear
                    :color="
                      item.subPercentage > 60
                        ? 'green'
                        : item.subPercentage < 45
                        ? 'orange'
                        : 'blue'
                    "
                    v-model="item.subPercentage"
                    :buffer-value="100"
                    height="20"
                  >
                     <template v-slot:default="{ value }">
                      <strong>{{ Math.ceil(value) }}%</strong>
                    </template>
                  
                  </v-progress-linear>


                </span>
              </td>
              <td>{{ item.startDate }}</td>
              <td>{{ item.endDate }}</td>
              <td>
                <v-btn
                  depressed
                  rounded
                  small
                  link
                  to="/reports/report-component"
                >
                  <v-icon style="height: 16px; font-size: 16px">mdi-eye</v-icon>
                </v-btn>
              </td>
            </tr>
          </tbody>
        </template>
      </v-simple-table>
    </v-card>
  </v-layout>
</template>


<script>
import { use } from "echarts/core";
import { CanvasRenderer } from "echarts/renderers";
import { PieChart } from "echarts/charts";
import {
  TitleComponent,
  TooltipComponent,
  LegendComponent,
} from "echarts/components";
import VChart, { THEME_KEY } from "vue-echarts";
import ProjectGauge from "../digitaltp_components/project_details/ProjectGauge.vue";
import PageTitle from "../../digitaltp_shared/page-title.vue";

use([
  CanvasRenderer,
  PieChart,
  TitleComponent,
  TooltipComponent,
  LegendComponent,
]);

export default {
  name: "GeneralReport",
  components: {
    VChart,
    ProjectGauge,
    PageTitle,
  },
  provide: {
    [THEME_KEY]: "white",
  },
  data() {
    return {
      reportData: [
        {
          name: "Digital Ecosystem",
          components: 4,
          subComponents: 8,
          startDate: "January 4, 2022",
          endDate: "December 4, 2023",
          percentage: 34,
          subPercentage: 50,
        },
        {
          name: "Digital Platform & Service",
          components: 6,
          subComponents: 18,
          startDate: "January 4, 2022",
          endDate: "December 4, 2025",
          percentage: 69,
          subPercentage: 80,
        },
        {
          name: "Digital Connectivity",
          components: 2,
          subComponents: 6,
          startDate: "January 4, 2022",
          endDate: "December 4, 2023",
          percentage: 49,
          subPercentage: 58,
        },
      ],
      option: {
        title: {
          text: "Project Vs Percentage Completion",
        },
        tooltip: {
          trigger: "axis",
        },
        // legend: {
        //   bottom: "left",
        //   data: ["This Month", "Last Month"],
        // },
        toolbox: {
          show: true,
          feature: {
            dataView: { show: true, readOnly: false },
            magicType: { show: true, type: ["line", "bar"] },
            restore: { show: true },
            saveAsImage: { show: true },
          },
        },
        calculable: true,
        xAxis: [
          {
            type: "category",
            // prettier-ignore
            data: ['Digital Ecosystem', 'Digital Connectivity', 'Digital Platform & Services'],
          },
        ],
        yAxis: [
          {
            type: "value",
          },
        ],
        series: [
          {
            name: "Percentage Completion (%)",
            type: "bar",
            data: [34, 69, 49],
            markPoint: {
              data: [
                { type: "max", name: "Max" },
                { type: "min", name: "Min" },
              ],
            },
            markLine: {
              data: [{ type: "average", name: "Avg" }],
            },
          },
        ],
      },
    };
  },
};
</script>

<style scoped>
.chart {
  height: 400px;
}
</style>

